import u from 'updeep';
import { handleActions } from 'redux-actions';
import * as actions from './readingListsActions';

const initialState = {
  isFetchingReadingList: false,
  readingList: null,
  isCreatingReadingList: false,
  isLikingReadingList: false,
  isEditingReadingList: false,
  isUpdatingReadingList: false,
  currentQuickViewList: null,
  isListQuickViewVisible: false,
  isFetchingStoryStatus: false,
  storyStatus: null,
  isSettingStoryStatus: false,
  readStoryStatus: null,
};

export default handleActions({
  [actions.fetchReadingListDetails]: (state, action) => u({
    isFetchingReadingList: true
  }, state),

  [actions.receiveReadingListDetails]: (state, action) => u({
    isFetchingReadingList: false,
    readingList: action.payload.ok ? action.payload.data : null
  }, state),

  [actions.postReadingListLike]: (state, action) => u({
    isLikingReadingList: true
  }, state),

  [actions.receiveReadingListLike]: (state, action) => u({
    isLikingReadingList: false,
    readingList: action.payload.readingList
  }, state),

  [actions.updateReadingList]: (state, action) => u({
    isUpdatingReadingList: true
  }, state),

  [actions.receiveUpdateReadingList]: (state, action) => u({
    isUpdatingReadingList: false,
    readingList: action.payload.readingList
  }, state),

  [actions.createReadingList]: (state, action) => u({
    isCreatingReadingList: true
  }, state),

  [actions.receiveCreateReadingList]: (state, action) => u({
    isCreatingReadingList: false
  }, state),

  [actions.createReadingListError]: (state, action) => u({
    isCreatingReadingList: false
  }, state),

  [actions.openListQuickView]: (state, action) => u({
    isListQuickViewVisible: true,
    currentQuickViewList: action.payload.list
  }, state),
  
  [actions.closeListQuickView]: (state, action) => u({
    isListQuickViewVisible: false,
    currentQuickViewList: null
  }, state),

  [actions.fetchStoryStatus]: (state, action) => u({
    isFetchingStoryStatus: true
  }, state),

  [actions.receiveStoryStatus]: (state, action) => u({
      isFetchingStoryStatus: false,
      storyStatus: action.payload.status,
  }, state),

  [actions.setStoryStatus]: (state, action) => u({
    isSettingStoryStatus: true
  }, state),

  [actions.receiveSetStoryStatus]: (state, action) => u({
    isSettingStoryStatus: false,
    readStoryStatus: action.payload.data
  }, state),

}, initialState);



// WEBPACK FOOTER //
// ./src/redux/readingListsReducer.js